import { Cart } from 'components'
import React from 'react'

const CartPage = () => {
  return (
    <div>
        <Cart/>
    </div>
  )
}

export {CartPage}
